// extracted by mini-css-extract-plugin
export default {"ExtraLink":"TabPanel_ExtraLink__brj+6","Indicator":"TabPanel_Indicator__7aR+F","Select":"TabPanel_Select__Br7Kd","Tab":"TabPanel_Tab__jGAAH","Tabs":"TabPanel_Tabs__SgX+N"};